import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';

export interface HelpDialogData {
  title: string;
  text: string;
}

@Component({
  selector: 'app-help-dialog',
  templateUrl: './help-dialog.component.html',
  styleUrls: ['./help-dialog.component.scss']
})
export class HelpDialogComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: HelpDialogData) {}

  ngOnInit(): void {
  }

}
